import errorHandler from '@/mixins/errorHandler';
import { get } from '@/services/Axios';

export default {
  mixins: [errorHandler],
  data() {
    return {
      reports: [],
      report: {},
      paginationReports: {},
      loadingReports: true,
      loadExportReport: false,
      loadReport: false
    };
  },
  methods: {
    async getReports(...param) {
      this.loadingReports = true;
      const parameter = param[0] || {};
      const params = {
        limit: parameter.limit || 10,
        page: parameter.page || 1,
        sort: parameter.sorts || 'report_datetime',
        dir: parameter.dir || 'DESC',
        filter: []
      };
      if (parameter.filters) {
        params.filter.push(...parameter.filters);
      }
      try {
        const {
          data: { results, pagination }
        } = await get('/report/list', { params });

        results.map((el) => {
          el.coverImage = require('@/assets/image-placeholder-300.png');
          if (el.reportAttachment.length > 0) {
            const image = el.reportAttachment.find(
              (file) => file.type == 'image'
            );
            if (image) {
              el.coverImage = image.url.compressed;
            }
          }
          return el;
        });

        this.reports = results;
        this.paginationReports = pagination;
        return results;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadingReports = false;
      }
    },
    async getReport(id) {
      this.loadReport = true;
      const params = {
        report_id: id
      };
      try {
        const { data } = await get('/report/detail', { params });
        this.report = data;
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadReport = false;
      }
    },
    async exportReport() {
      this.loadExportReport = true;
      try {
        const {
          data: { url }
        } = await get('/report/export');
        window.open(`${url}?download=1`);
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadExportReport = false;
      }
    }
  }
};
